import { lazy } from 'react';

export const BimCalculationStructure = lazy(() =>
    import('./BimCalculationStructure').then((module) => ({ default: module.BimCalculationStructure })),
);
